// Replace two or more consecutive spaces with a single space

const cleanText = (text: string | undefined): string => {
  return (text || '').replace(/ {2,}/g, ' ').trim();
};

export default cleanText;
